import { medias } from '@/utils/sizes';
import styled from 'styled-components';

export const CookieBannerContainer = styled.div`
box-sizing: border-box;
  background-color: white;
  border-top: 1px solid var(--c-border);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--spacing-component-inner-lg);
  grid-template-columns: 1fr;
  padding: var(--spacing-component-inner-lg) !important;
  width: 100%;

  ${medias.min.desktop} {
    flex-direction: row;
  }

  p {
    line-height: 1.5;
  }

  .cookies-title {
    font-size: 21px;
  }

  .cookies-content {
    font-size: 16px;
  }

  a {
    color: var(--c-font-secondary);
    transition: color var(--tr-base);

    &:hover {
      color: var(--c-font-primary);
    }
  }

  button {
    height: 50px;
    margin: auto 0;
    padding: 0 var(--spacing-component-inner-sm);
    transition:
      background-color var(--tr-fast),
      color var(--tr-fast),
      border-color var(--tr-fast);

    span {
      color: currentColor;
      font-size: 21px;
      white-space: nowrap;
    }
  }

  .btn-accept {
    background-color: var(--c-black);
    color: white;

    &:hover {
      background-color: var(--c-black-200);
    }
  }

  .btn-reject {
    background-color: transparent;
    color: var(--c-black);
    border: 1px solid var(--c-border);

    &:hover {
      border-color: var(--c-black);
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--spacing-component-inner);

  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-component-inner-xs);

  ${medias.min.desktop} {
    width: 90%;
    max-width: 1300px;
  }
`;
